"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Application = void 0;
const CircularProgress_1 = require("@material-ui/core/CircularProgress");
const default_1 = require("client/components/material/theme/default");
const router_1 = require("client/components/router");
const title_bar_1 = require("client/components/title-bar");
const app_settings_1 = require("client/modules/app-settings");
const asset_approvals_1 = require("client/modules/asset-approvals");
const audit_1 = require("client/modules/audit");
const billing_1 = require("client/modules/billing");
const dashboard_1 = require("client/modules/dashboard");
const dispense_1 = require("client/modules/dispense");
const eob_1 = require("client/modules/eob");
const erx_1 = require("client/modules/erx");
const financial_1 = require("client/modules/financial");
const inventory_1 = require("client/modules/inventory");
const inventory_order_1 = require("client/modules/inventory-order");
// import { RuleAddForm } from 'client/modules/inventory-order/tabs/order-rules/modules/rule-add-form';
const kitchen_sink_1 = require("client/modules/kitchen-sink");
const labels_1 = require("client/modules/labels");
const ledger_1 = require("client/modules/ledger");
const not_found_1 = require("client/modules/not-found");
const orders_1 = require("client/modules/orders");
const mobile_pad_1 = require("client/modules/pads/modules/mobile-pad");
const patients_1 = require("client/modules/patients");
const prescribe_1 = require("client/modules/prescribe");
const providers_1 = require("client/modules/providers");
const reporting_1 = require("client/modules/reporting");
const sites_1 = require("client/modules/sites");
const stocks_1 = require("client/modules/stocks");
const support_1 = require("client/modules/support");
const sync_1 = require("client/modules/sync");
const users_1 = require("client/modules/users");
const store_1 = require("client/modules/users/store");
const moment_utils_1 = require("material-ui-pickers/utils/moment-utils");
const MuiPickersUtilsProvider_1 = require("material-ui-pickers/utils/MuiPickersUtilsProvider");
const Reboot_1 = require("material-ui/Reboot");
const styles_1 = require("material-ui/styles");
const mobx_react_1 = require("mobx-react");
const React = require("react");
const user_1 = require("shared/user");
require("./application.less");
const ReactTooltip = require("react-tooltip");
// import { Modal } from "components/modal";
//E-048
const modal_1 = require("client/components/modal");
const button_1 = require("client/components/material/button");
const payment_process_1 = require("../../modules/payment-process"); // D-002.55
let Application = class Application extends router_1.Router {
    constructor(props) {
        super(props);
        this.state = { chatOpen: false, deleteDialogOpen: false, timeTimer: 30 };
        //E-048
        this.events = [
            "load",
            "mousemove",
            "mousedown",
            "click",
            "scroll",
            "keypress"
        ];
        this.showModal = false;
        this.handleStayLoggedIn = () => {
            this.resetTimer();
            this.setState({ deleteDialogOpen: false, timeTimer: 30 }); //E-048.2
        };
        this.logoutAction = () => {
            if (store_1.usersStore.permissions.LogOutUser) {
                localStorage.clear();
                // window.location.pathname = "/"; // Home page
                localStorage.setItem("token", "");
                this.renderAutoLogOutRedirect();
            }
            // return null
        };
        this.handleChatTooltipOpen = () => {
            if (this.state.chatOpen) {
                return;
            }
            this.setState({ chatTooltipOpen: true });
        };
        this.handleChatTooltipClosed = () => {
            this.setState({ chatTooltipOpen: false });
        };
        this.receiveMessage = (event) => {
            if (event.data.fn === "restoreWindow") {
                this.setState({ chatOpen: true });
                ReactTooltip.hide();
            }
            else if (event.data.fn === "minimizeWindow") {
                this.setState({ chatOpen: false });
            }
        };
        this.redirectHomepage = () => {
            if (localStorage.getItem("initialLogin") &&
                JSON.parse(localStorage.getItem("initialLogin"))) {
                localStorage.removeItem("initialLogin");
                const { homepage, siteId } = store_1.usersStore.user.value;
                let route = "/";
                switch (homepage) {
                    case user_1.UserHomepage.Dashboard:
                        route = "/dashboard";
                        break;
                    case user_1.UserHomepage.Claims:
                        route = "/claims";
                        break;
                    case user_1.UserHomepage.Inventories:
                        route = `/lots/pharmacies/${siteId}/inventory-lot`;
                        break;
                    case user_1.UserHomepage.Order:
                        route = "/order/quickorder";
                        break;
                    case user_1.UserHomepage.Prescribe:
                        route = "/prescribe";
                        break;
                    case user_1.UserHomepage.Labels:
                        route = "/labels";
                        break;
                    case user_1.UserHomepage.Dispense:
                        route = "/dispense";
                        break;
                    case user_1.UserHomepage.Reports:
                        route = "/reports";
                        break;
                    case user_1.UserHomepage.Ledger:
                        route = "/ledger";
                        break;
                    case user_1.UserHomepage.Eob:
                        route = "/eob/eobfees";
                        break;
                    case user_1.UserHomepage.AssetApprovals:
                        route = "/assetapprovals";
                        break;
                    case user_1.UserHomepage.Financials:
                        route = "/financials";
                        break;
                    case user_1.UserHomepage.PatientPayments: // D-002.55
                        route = "/patientPayments";
                        break;
                    default:
                        break;
                }
                router_1.RouteManager.transitionTo(route);
            }
        };
        router_1.RouteManager.setNotFoundComponent(not_found_1.NotFoundModule);
        this.addRoute("audit", /^\/audit?$/, audit_1.AuditModule);
        this.addRoute("dashboard", /^\/(dashboard)?$/, dashboard_1.DashboardModule);
        this.addRoute("financials", /^\/financials/, financial_1.FinancialModule);
        this.addRoute("patientPayments", /^\/patientPayments/, payment_process_1.PaymentProcessModule); // D-002.55
        this.addRoute("formulary", /^\/formulary/, inventory_1.InventoryModule);
        this.addRoute("order", /^\/order/, inventory_order_1.InventoryOrderModule);
        this.addRoute("users", /^\/users/, users_1.UsersModule);
        this.addRoute("patients", /^\/patients/, patients_1.PatientsModule);
        this.addRoute("providers", /^\/providers/, providers_1.ProvidersModule);
        this.addRoute("pharmacies", /^\/pharmacies/, sites_1.SitesModule);
        this.addRoute("claims", /^\/claims/, orders_1.OrdersModule);
        this.addRoute("sink", /^\/(kitchen-)?sink/, kitchen_sink_1.KitchenSinkModule);
        this.addRoute("sync", /^\/sync/, sync_1.SyncModule);
        this.addRoute("erx", /^\/erx$/, erx_1.ErxModule);
        this.addRoute("reporting", /^\/reports/, reporting_1.ReportingModule);
        this.addRoute("lots", /^\/lots/, stocks_1.StocksModule);
        this.addRoute("ledger", /^\/ledger/, ledger_1.LedgerModule);
        this.addRoute("eob", /^\/eob/, eob_1.EobModule);
        // this.addRoute('new', /^\/order\/rules\/new\/?$/, RuleAddForm);
        this.addRoute("support", /^\/support/, support_1.SupportModule);
        this.addRoute("settings", /^\/(app-)?settings/, app_settings_1.AppSettingsModule);
        this.addRoute("assetapprovals", /^\/assetapprovals/, asset_approvals_1.AssetApprovalsModule);
        this.addRoute("prescribe", /^\/prescribe/, prescribe_1.PrescribeModule);
        this.addRoute("labels", /^\/labels/, labels_1.LabelsModule);
        this.addRoute("dispense", /^\/dispense/, dispense_1.DispenseModule);
        this.addRoute("billing", /^\/billing/, billing_1.BillingModule);
        this.addRoute("pads", /^\/pads\/(\d+)\/(\d+)/, mobile_pad_1.PadModule);
    }
    //E-048
    handleLogoutTimer() {
        this.timer = setTimeout(() => {
            Object.values(this.events).forEach(item => {
                window.removeEventListener(item, this.resetTimer);
            });
            this.setState({ deleteDialogOpen: true }); //E-048.2
            this.timerInterval = setInterval(() => {
                if (this.state.timeTimer == 0) {
                    clearTimeout(this.timer);
                    clearInterval(this.timerInterval);
                    localStorage.setItem("token", "");
                    this.renderAutoLogOutRedirect();
                    this.resetTimer();
                }
                this.setState({ timeTimer: this.state.timeTimer - 1 });
            }, 1000);
        }, this.logOutTime * 60 * 1000 - 30000); // 10000ms = 10secs. You can change the time. set for 1 min 300000 // 10 min 600000
    }
    //  this.logOutTime * 60 * 1000 - 30000
    resetTimer() {
        if (this.timer)
            clearTimeout(this.timer);
        if (this.timerInterval)
            clearInterval(this.timerInterval);
    }
    async componentDidMount() {
        var _a;
        await store_1.usersStore.loadUser();
        if (store_1.usersStore.user.value.groupId != 1 && store_1.usersStore.user.value.groupId != 4) {
            if ((_a = store_1.usersStore === null || store_1.usersStore === void 0 ? void 0 : store_1.usersStore.permissions) === null || _a === void 0 ? void 0 : _a.LogOutUser) {
                let getResponse = localStorage.getItem("userdata");
                this.logOutTime = Number(getResponse);
                console.log((this.logOutTime * 60 * 1000) - 30000);
                Object.values(this.events).forEach(item => {
                    window.addEventListener(item, () => {
                        this.resetTimer();
                        this.handleLogoutTimer();
                    });
                });
            }
        }
    }
    render() {
        window.addEventListener("message", this.receiveMessage, true);
        // return this.renderLoading();
        // @tkay save href to localstorage if href includes /order/review and #access_token
        if (location.href.includes("/order/review") &&
            location.href.includes("#po_token")) {
            localStorage.setItem("purchaseOrderRefToken", JSON.stringify(location.href));
        }
        if (store_1.usersStore.loading)
            return this.renderLoading();
        if (!store_1.usersStore.user.value)
            return this.renderRedirect();
        this.redirectHomepage();
        let chatURL = "http://localhost:8080/" + store_1.usersStore.sessionKey;
        if (window.location.host === "pharmacy.mdpr.in") {
            chatURL = "https://livechat.mdpr.in/" + store_1.usersStore.sessionKey;
        }
        if (window.location.host === "uat-pharmacy.themedportal.com") {
            chatURL = "https://uat.themedportal.com/" + store_1.usersStore.sessionKey;
        }
        if (window.location.host === "pharmacy.themedportal.com") {
            chatURL = "https://livechat.themedportal.com/" + store_1.usersStore.sessionKey;
        }
        // Log out notification pops up behind dropdown E-048.5 chnage div section hen
        // E-048.5 chnags 
        return (React.createElement("div", { className: "application" },
            React.createElement("div", { style: { zIndex: 5999 } }, this.state.deleteDialogOpen && (React.createElement(modal_1.Modal
            // onCancel={this.handleModalClose} // E-048.5 updated  
            , { 
                // onCancel={this.handleModalClose} // E-048.5 updated  
                height: "fit-content", top: "25%", width: "35%", borderRadius: "5px" },
                React.createElement("div", { className: "filter-bar", style: { zIndex: 9999 } },
                    React.createElement("div", { className: "", 
                        // style={{zIndex:'10000'}}
                        // style={{ width: "65vw" }}
                        style: { fontFamily: "sans-serif", fontSize: 16 } },
                        "Your session has expired!",
                        React.createElement("div", { style: { marginTop: 20, display: "flex" } },
                            "For your security, Your session is about to expire! in",
                            React.createElement("span", { style: { color: "#FF0000", fontWeight: 800, marginLeft: 5, marginRight: 5, marginTop: -3 } }, `00:${this.state.timeTimer}`),
                            "due to inactivity."),
                        React.createElement("p", null, " If you continue, the system will not sign out immediately.")),
                    React.createElement("div", { style: {
                            display: "flex",
                            justifyContent: "flex-end",
                            marginTop: "1rem"
                        } },
                        React.createElement(button_1.MaterialButton, { className: "filter-bar__today-button", primary: true, onClick: this.handleStayLoggedIn, style: { marginRight: "1em", maxWidth: "300px" } }, "Continue"),
                        React.createElement(button_1.MaterialButton, { className: "filter-bar__today-button", primary: true, onClick: this.logoutAction, style: { marginRight: "1em" } }, "Log Out"))))
            // E-048.2 
            )),
            React.createElement(Reboot_1.default, null),
            React.createElement(MuiPickersUtilsProvider_1.default, { utils: moment_utils_1.default },
                React.createElement(styles_1.MuiThemeProvider, { theme: default_1.defaultTheme },
                    React.createElement(title_bar_1.TitleBar, { user: store_1.usersStore.user.value, isDisabled: this.state.deleteDialogOpen }),
                    React.createElement("main", { className: "main-content" }, super.render()),
                    React.createElement("div", null,
                        React.createElement(ReactTooltip, { effect: "solid", place: "left", delayShow: 100, "data-type": "info", multiline: true, disable: this.state.chatOpen }),
                        store_1.usersStore.sessionKey ? (React.createElement("iframe", { "data-tip": this.state.chatOpen ? null : "Live Support", src: chatURL, frameBorder: 0, style: {
                                position: "absolute",
                                bottom: 0,
                                right: 0,
                                height: this.state.chatOpen ? "500px" : "100px",
                                width: this.state.chatOpen ? "500px" : "100px",
                                zIndex: 10
                            } })) : null)))));
    }
    renderLoading() {
        return (React.createElement("div", { style: {
                width: "100px",
                height: "100px",
                backgroundColor: "#f0f0f0",
                position: "absolute",
                top: "0",
                bottom: "0",
                left: "0",
                right: "0",
                margin: "auto"
            } },
            React.createElement(CircularProgress_1.default, { classes: {}, value: 50, size: 100 })));
    }
    renderRedirect() {
        // cConnor send you to portal if not logged in
        let url = "http://localhost:3000/";
        if (window.location.host === "3.131.52.72:3010") {
            url = "http://3.131.52.72/";
        }
        if (window.location.host === "uat-pharmacy.themedportal.com") {
            url = "https://uat.themedportal.com/";
        }
        if (window.location.host === "pharmacy.themedportal.com") {
            url = "https://themedportal.com/";
        }
        return (window.location.href = url);
    }
    renderAutoLogOutRedirect() {
        // cConnor send you to portal if not logged in
        let url = "http://3.131.52.72/autoLogOut";
        if (window.location.host === "3.131.52.72:3010") {
            url = "http://3.131.52.72/autoLogOut";
        }
        if (window.location.host === "uat-pharmacy.themedportal.com") {
            url = "https://uat.themedportal.com/autoLogOut";
        }
        if (window.location.host === "pharmacy.themedportal.com") {
            url = "https://themedportal.com/autoLogOut";
        }
        return (window.location.href = url);
    }
};
Application = __decorate([
    mobx_react_1.observer
], Application);
exports.Application = Application;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/application/application.tsx
// module id = 3153
// module chunks = 0